export default __webpack_public_path__ + "9f7fad4a04c575d62d16135e3f1a47bd.png";